<template>
  <div>
    <base-material-card color="secondary" icon="mdi-account-multiple" :title="$t('users_registry')">
      <v-layout justify-center style="flex-wrap: wrap">
        <v-radio-group row justify-center v-model="filter" @change="loadTable()">
          <v-radio :label="$t('affiliated')" value="tesserati"></v-radio>
          <v-radio :label="$t('affiliated_external')" value="esterni"></v-radio>
          <v-radio :label="$t('members')" value="soci"></v-radio>
          <v-radio :label="$t('honorary_members')" value="sociOnorari"></v-radio>
          <v-radio :label="$t('supporters')" value="utenti"></v-radio>
          <v-radio :label="$t('not_confirmed_p')" value="nonConfermati"></v-radio>
          <v-radio :label="$t('all_m_p')" value="tutti"></v-radio>
          <v-radio v-if="ifEnte" :label="$t('other_portal_users')" value="master"></v-radio>
        </v-radio-group>
        <v-btn class="mx-2 my-2" small @click="createUser" color="primary">
          <v-icon class="mr-2">mdi-account-plus</v-icon>{{ $t("create_user") }}
        </v-btn>
        <v-btn class="mx-2 my-2" small @click="extractCsv" color="primary">
          <v-icon class="mr-2">mdi-account-arrow-down</v-icon>{{ $t("extract_csv") }}
        </v-btn>
        <v-btn v-on:click="clickUploadCsv" color="primary" class="mx-2 my-2" small>
          <v-icon class="mr-2">mdi-account-arrow-up</v-icon>{{ $t("import_users_csv") }}
        </v-btn>
      </v-layout>
      <DataTables @showUser="showUser" @tesseramento="tesseramento" @deleteUser="deleteUser"
        @svincoloTesserato="svincoloTesserato" @importMasterUser="importMasterUser" :headers="headers"
        :tableData="tableData"></DataTables>
    </base-material-card>
    <user-edit-profile @isUpdated="loadTable" ref="userEditProfileDialog"></user-edit-profile>
    <profile-page @isUpdated="loadTable" ref="profilePageDialog"></profile-page>
    <upload-users @isUpdated="loadTable" ref="uploadUsersDialog"></upload-users>
  </div>
</template>

<script>
import DataTables from "@/components/base/DataTables.vue";
import profilePage from "@/app/UserProfile.vue";
import uploadUsers from "@/app/uploadUsers.vue";
import userEditProfile from "@/widget/userEditProfile.vue";

import Swal from "sweetalert2";
let _ = this;
export default {
  name: "list-users",
  components: {
    DataTables,
    userEditProfile,
    uploadUsers,
    profilePage,
  },
  data() {
    return {
      filter: "tesserati",
      ifEnte: false,
      headers: [],
      files: [],
      tableData: [],
    };
  },

  methods: {
    clickUploadCsv() {
      //this.$refs.uploadFileForm.$el.click();
      this.$refs.uploadUsersDialog.open();
    },
    extractCsv() {
      let link = this.authorizeLink("/auth/portal/csv/getFileUtenti");
      window.open(link);
    },
    deleteUser(item) {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.chiamataAxios(
            "DELETE",
            "/auth/portal/deleteUser/" + item.masterId
          ).then((response) => {
            if (response.msg.esito) _.loadTable();
          });
        }
      });
    },
    svincoloTesserato(item) {
      let _ = this;
      Swal.fire({
        title: this.$t("release_affiliated"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.chiamataAxios(
            "DELETE",
            "/auth/tesseramenti/svincoloTesserato/" + item.masterId,
            { msg: "always" }
          ).then((response) => {
            if (response.msg.esito) _.loadTable();
          });
        }
      });
    },
    showUser(item) {
      this.$refs.profilePageDialog.open(item.masterId, 4);
    },
    importMasterUser(item) {
      let _ = this;
      Swal.fire({
        title: this.$t("import_in_portal"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.chiamataAxios(
            "POST",
            "/auth/portal/importMasterUser/" + item.masterId,
            { msg: "always", dialogLoader: true }
          ).then((response) => {
            if (response.msg.esito) _.loadTable();
          });
        }
      });
    },
    tesseramento(item) {
      this.$router.push("/portal/tesserati/tesseramento/" + item.masterId);
    },
    createUser() {
      this.$refs.userEditProfileDialog.open("ADD");
    },

    loadTable() {
      let url = "/auth/portal/listUsers";
      let _ = this;
      let canTesserateOther = _.checkUserRole("tesseramenti", "TESSERATE_OTHER_USER");
      _.tableData = [];
      if (_.filter === "master") {
        _.headers = [
          { text: this.$t("avatar"), value: "avatarUrl", type: "image" },
          { text: this.$t("surname"), value: "surname" },
          { text: this.$t("name"), value: "name" },
          { text: this.$t("email"), value: "email" },
          { text: this.$t("residence_address"), value: "resCity" },
          { text: this.$t("telephone"), value: "telephone" },
          { text: this.$t("eta"), value: "eta", type: "numeric" },
          { text: this.$t("portals"), value: "portaliString", type: "text" },
        ];
      } else {
        _.headers = [
          { text: this.$t("id"), value: "masterId" },
          { text: this.$t("avatar"), value: "avatarUrl", type: "image" },
          { text: "", value: "onorario", type: "icons" },
          { text: this.$t("surname"), value: "surname" },
          { text: this.$t("name"), value: "name" },
          { text: this.$t("email"), value: "email" },
          { text: this.$t("residence_address"), value: "resCity" },
          { text: this.$t("telephone"), value: "telephone" },
          { text: this.$t("eta"), value: "eta", type: "numeric" },
          { text: this.$t("last_season"), value: "stagione" },
          {
            text: this.$t("type_affiliation_card"),
            value: "tesseraClub",
            type: "html",
          },
          {
            text: this.$t("number_affiliation"),
            value: "tesseraEnte",
            type: "html",
          },
          { text: this.$t("date_affiliation"), value: "dateTes", type: "date" },
        ];
        if (_.filter === "soci") {
          _.headers.push({
            text: this.$t("release_affiliated"),
            value: "dateSvi",
            type: "date",
          });
        }
      }
      _.headers.push({
        text: this.$t("options"),
        value: "options",
        type: "buttons",
      });
      _.isFetching = true;
      this.chiamataAxios("POST", url, {
        getAttrib: true,
        body: { filter: { type: _.filter } },
      }).then((response) => {
        // Aggiunge actions e icona validazione
        let list = response.data.map(function (item) {
          if (_.filter === "master") {
            item.portaliString = item.portali.join(", ");
            if (!item.portali.includes(window.systemData.custId)) {
              item.options = [
                {
                  icon: "mdi-home-import-outline",
                  color: "warning",
                  text: _.$t("import_in_portal"),
                  function: "importMasterUser",
                },
              ];
            }
            return item;
          } else {
            //item.url = _.authorizeLink(item.url);
            item.stagione =
              item.tesseraInterna.length > 0
                ? item.tesseraInterna[0].stagione
                : "";
            item.dateTes =
              item.tesseraInterna.length > 0
                ? item.tesseraInterna[0].dateTes
                : "";
            item.tesseraClub =
              item.tesseraInterna.length > 0
                ? '<h4 style="color: ' +
                item.tesseraInterna[0].asdTesHexColor +
                ';">' +
                item.tesseraInterna[0].asdTesTipo +
                " - " +
                item.tesseraInterna[0].asdTesNum +
                "</h4>"
                : "";
            // Se club è esterno, aggiungo info club
            if (
              item.tesseraInterna.length > 0 &&
              item.tesseraInterna[0].asdCode !== window.systemData.ASD.code
            ) {
              item.tesseraClub =
                "<b>" +
                item.tesseraInterna[0].asdRagSoc +
                "</b><br>" +
                item.tesseraClub;
            }
            item.tesseraEnte =
              item.tesseraEnte.length > 0
                ? '<h4 style="color: ' +
                  item.tesseraEnte[0].asdTesHexColor +
                  ';">' +
                  item.tesseraEnte[0].asdTesTipo +
                  " - " +
                  item.tesseraEnte[0].asdTesNum
                  ? item.tesseraEnte[0].asdTesNum
                  : "" + "</h4>"
                : "";
            item.dateTes =
              item.tesseraInterna.length > 0 && item.tesseraInterna[0].dateTes
                ? item.tesseraInterna[0].dateTes
                : null;
            item.dateSvi =
              item.tesseraInterna.length > 0 &&
                item.tesseraInterna[0].svincolato === 1
                ? item.tesseraInterna[0].dateEnd
                : null;
            if (item.socioOnorario === 1)
              item.onorario = [{ icon: "mdi-star", color: "yellow" }];
            item.options = [
              {
                icon: "mdi-account-edit",
                color: "green",
                text: _.$t("show_user"),
                function: "showUser",
              },
            ]; 
            if(canTesserateOther){
              item.options.push({
                icon: "mdi-credit-card-outline",
                color: "primary",
                text: _.$t("affiliation"),
                function: "tesseramento",
              });
            }
            if (!item.asdTesId)
              item.options.push({
                icon: "mdi-delete-outline",
                color: "error",
                text: _.$t("delete_user"),
                function: "deleteUser",
              });
            if (_.filter === "tesserati") {
              item.options.push({
                icon: "mdi-exit-run",
                color: "warning",
                text: _.$t("release_affiliated"),
                function: "svincoloTesserato",
              });
            }
            return item;
          }
        });

        _.tableData = list;
        _.isFetching = false;
      });
    },
  },
  mounted() {
    this.ifEnte = window.systemData.ifEnte;
    this.loadTable();
  },
};
</script>

